import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { IndexEntityService, IndexListValueService, OrganizationService, ReferenceService } from '../../../apiModule1';
import { MultiSelect3Component } from '../../../../shared/components/multi-select3/multi-select3.component';
import { ChoiseComponent } from '../../../../shared/components/choise/choise.component';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

@Component({
    selector: 'pas-dialog-index-list-value',
    standalone: true,
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss', '../../index-entity/dialog/dialog.component.scss', '../../index-entity/filling-method/filling-method.component.scss'],
    imports: [
        MatFormField,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatIcon,
        MatIconButton,
        MatButton,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MultiSelect3Component,
        ChoiseComponent,
    ],
})
export class DialogComponent implements OnInit {
    isNew: boolean = false;
    periods: CriterionPeriod[] = [];
    indexItems: any[] = [];

    years: IdName[] = [
        { id: 1, name: '2024' },
        { id: 2, name: '2025' },
        { id: 3, name: '2026' },
        { id: 4, name: '2027' },
    ];

    quarters: IdName[] = [
        { id: 1, name: '1' },
        { id: 2, name: '2' },
        { id: 3, name: '3' },
        { id: 4, name: '4' },
    ];

    form = new FormGroup({
        index: new FormControl<IndexEntry[] | null>(null, [Validators.required]),
        organization: new FormControl<Organization[] | null>(null, [Validators.required]),
        period: new FormControl<CriterionPeriod | null>(null, [Validators.required]),
        indexItem: new FormControl<any | null>(null, [Validators.required]),
        year: new FormControl<IdName | null>(null, [Validators.required]),
        quarter: new FormControl<IdName | null>(null),
    });

    get period(): CriterionPeriod | null {
        return this.form.get('period')?.value!;
    }

    constructor(
        public dialogRef: MatDialogRef<DialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
        public dataService: IndexListValueService,
        public indexEntityService: IndexEntityService,
        public organizationService: OrganizationService,
        public referenceService: ReferenceService,
    ) {
        this.isNew = data['isNew'];

        if (!this.isNew) {
            combineLatest([
                this.referenceService.apiReferencePeriodsGet().pipe(map(v => v.values)),
                this.dataService.apiIndexlistvalueIdGet({ id: this.data['id'] })
            ]).subscribe(res => {
                const [periods, i] = res as any;
                if (!i) return;

                this.periods = periods || [];

                if (i.index) {
                    this.form.get('index')!.setValue([i.index], { emitEvent: false });
                    this.loadIndexItems(i.index.id, i.indexItem?.id);
                }

                i.organization && this.form.get('organization')!.setValue([i.organization]);
                i.period && this.form.get('period')!.setValue(i.period);
                i.year && this.form.get('year')!.setValue(this.years.find(v => +v.name == i.year) || null);
                i.quarter && this.form.get('quarter')!.setValue(this.quarters.find(v => +v.name == i.quarter) || null);
            });
        } else {
            this.referenceService.apiReferencePeriodsGet().pipe(map(v => v.values)).subscribe((v: CriterionPeriod[]) => {
                this.periods = v || [];
            });
        }
    }

    ngOnInit() {
        this.form.get('index')!.valueChanges.subscribe(indexes => {
            const index = indexes?.[0];

            if (!index?.id) {
                this.indexItems = [];
                this.form.get('indexItem')!.setValue(null);
                return;
            }

            this.loadIndexItems(index.id);
        });
    }

    private loadIndexItems(indexId: number, selectedItemId?: number) {
        this.indexEntityService.apiIndexIdGet({ id: indexId }).subscribe((index: any) => {
            this.indexItems = index?.indexItems || [];

            if (selectedItemId) {
                this.form.get('indexItem')!.setValue(this.indexItems.find(v => v.id === selectedItemId) || null);
            } else {
                this.form.get('indexItem')!.setValue(null);
            }
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onApply() {
        const index = (this.form.get('index')!.value as IndexEntry[])[0];
        const organization = (this.form.get('organization')!.value as Organization[])[0];

        const res: any = {
            index: index,
            indexEntityId: index.id,
            organization: organization,
            period: this.form.get('period')!.value || this.periods[0],
            id: this.data['id'],
            indexItem: this.form.get('indexItem')!.value,
            year: +(this.form.get('year')!.value?.name || this.data['year']),
            quarter: this.period?.name === 'Квартальная' ? +(this.form.get('quarter')!.value?.name || this.data['quarter'] || 0) : 0,
            status: this.data['status'],
        };

        this.dialogRef.close(res);
    }
}
